var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-btn',{staticClass:"page-button-close-root absolute",attrs:{"icon":"img:ui/room_tab_close.png","padding":"none"}})}
var staticRenderFns = []

export { render, staticRenderFns }